import { useEffect, useState } from "react";
import { useNavigate } from "../../lib/i18n";
import { Search } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { api, fmt } from "../../lib/api";

export function SearchDialog({ open, onOpenChange }) {
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    if (q.length < 2) { setRes([]); return; }
    const t = setTimeout(() => api.get("/products", { params: { q, limit: 6 } }).then((r) => setRes(r.data)), 220);
    return () => clearTimeout(t);
  }, [q]);

  const go = (path) => { onOpenChange(false); setQ(""); nav(path); };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl bg-ivoire p-0 gap-0">
        <DialogTitle className="sr-only">Recherche</DialogTitle>
        <form onSubmit={(e) => { e.preventDefault(); go(`/boutique?q=${encodeURIComponent(q)}`); }} className="flex items-center gap-3 border-b border-beige px-6 py-5">
          <Search className="text-bois" size={20} />
          <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Chêne, granulés, poêle, serviteur…" className="w-full bg-transparent font-serif text-2xl text-brun outline-none placeholder:text-pierre/50" data-testid="search-input" />
        </form>
        <div className="max-h-[60vh] overflow-y-auto p-3">
          {res.map((p) => (
            <button key={p.id} onClick={() => go(`/produit/${p.slug}`)} className="flex w-full items-center gap-4 rounded-md p-3 text-left hover:bg-creme" data-testid={`search-result-${p.slug}`}>
              <img src={p.images?.[0]} alt="" className="h-14 w-14 rounded object-cover" />
              <span className="flex-1"><span className="block font-medium text-brun">{p.name}</span><span className="text-xs text-pierre">{p.short_description?.slice(0, 70)}…</span></span>
              <span className="font-serif text-lg text-brun">{fmt(p.price)}</span>
            </button>
          ))}
          {q.length >= 2 && res.length === 0 && <p className="p-6 text-center text-sm text-pierre">Aucun produit trouvé pour « {q} ».</p>}
          {q.length < 2 && <p className="p-6 text-center text-xs uppercase tracking-[0.2em] text-pierre">Suggestions : chêne · hêtre · granulés · insert · range-bûches</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
